import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';

export default function AuthCallback() {
  const nav = useNavigate();
  const { googleLogin } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || '';
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    (async () => {
      if (!sessionId) { nav('/login'); return; }
      try {
        await googleLogin(sessionId);
        window.history.replaceState(null, '', '/app');
        toast.success('Signed in with Google');
        nav('/app', { replace: true });
      } catch {
        toast.error('Google sign-in failed');
        nav('/login', { replace: true });
      }
    })();
  }, [googleLogin, nav]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#090A0F]">
      <div className="text-center">
        <div className="w-10 h-10 rounded-full border-2 border-[#FF4D00] border-t-transparent animate-spin mx-auto mb-4" />
        <div className="text-slate-400 font-mono text-sm">Completing sign-in…</div>
      </div>
    </div>
  );
}
